export default __webpack_public_path__ + "images/ada-logo.11ea5640499391da138c92eb01a8a67f.png";